import { createLogger } from 'redux-logger';

import { configureStore } from '@reduxjs/toolkit';

import { meetingManagement } from 'services/meetingManagement';
import { pollManagement } from 'services/pollManagement';
import { reactionManagement } from 'services/reactionManagement';
import { topicCategoryManagement } from 'services/topicCategoryManagement';
import { topicManagement } from 'services/topicManagement';
import { voteManagement } from 'services/voteManagement';

const logger = createLogger();

export const microfrontendReducers = {
  [voteManagement.reducerPath]: voteManagement.reducer,
  [topicManagement.reducerPath]: topicManagement.reducer,
  [topicCategoryManagement.reducerPath]: topicCategoryManagement.reducer,
  [meetingManagement.reducerPath]: meetingManagement.reducer,
  [pollManagement.reducerPath]: pollManagement.reducer,
  [reactionManagement.reducerPath]: reactionManagement.reducer,
};

export const microfrontendMiddleware = [
  voteManagement.middleware,
  topicManagement.middleware,
  topicCategoryManagement.middleware,
  meetingManagement.middleware,
  pollManagement.middleware,
  reactionManagement.middleware,
  logger,
];

export const store = configureStore({
  reducer: {
    ...microfrontendReducers,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(...microfrontendMiddleware),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
